module.exports = __webpack_public_path__ + "static/media/X2.7fa43822.png";